<div class="flex items-center mx-4 mb-2 mt-5">
    <img (click)="backClicked()" class="rounded-full w-6 h-6 bg-blue-500 cursor-pointer " src="assets/back-icon.svg">
    <p class="text-2xl ml-5 font-semibold  bg-color-white">Welcome!</p>
</div>
<div class="flex">
    <div>
        <div class="main-container rounded-2xl px-7 py-4 bg-gray-200 ml-5 mb-3" style="font-family: Montserrat;">
            <div class="flex">
                <p class="text-gray-600 ">Custom code:</p>
            </div>
            <div class="flex items-center relative">    
                <p class="font-semibold">{{customCodes.code}}</p>
                <div>
                     <img (click)="copyMessage(customCodes.code, 'code')" style="cursor: pointer;" src="assets/copy.png" alt="Copy" class="ml-2"> 
                     <p *ngIf="codeCopied" class="copy-message">{{copiedMessage}}</p>
                </div>
            </div>  
        </div>
        <div  class="main-container rounded-2xl bg-gray-200 px-7 py-8 ml-5">
                <div class="h-auto flex flex-col gap-3" style="font-family: Montserrat;" >
                    <p class="text-gray-600">Custom code Link:</p>
                    <p class="text-gray-600 ">Authentication:</p>
                    <span class="text-gray-600 ">{{listTypeLabel}}:</span>
                </div>
                <div class="h-auto flex flex-col w-auto gap-3 font-medium relative" style="font-family: Montserrat;">
                    <p class="flex items-center">Code Link <img (click)="copyMessage(customCodeLink?.shareable_link,'link')" style="cursor: pointer;" src="assets/copy.png" alt="Copy" class="ml-2"></p>
                    <p *ngIf="linkCopied" class="copy-message">{{copiedMessage}}</p>
                    <div class="flex">
                        <div [ngClass]="{'bg-yellow-500': isActive, 'bg-white': !isActive}" class="flex bg-yellow-500 rounded-2xl w-20 items-center justify-center gap-1 ">
                            <img [src]="isActive ? 'assets/green-icon.svg' : 'assets/gray-icon.svg'">
                            <span style="font-size: 12px;">{{ isActive ? 'Active' : 'Inactive' }}</span>
                        </div>
                            <span class="ml-5 text-center text-lg font-medium leading-5 tracking-tighter text-blue-500 cursor-pointer" (click)="goTo()">View details</span>
                    </div>
                    <div class="h-auto flex gap-3 items-center">
                        <ng-container *ngFor="let item of currentList | keyvalue; let last = last">
                            {{getArrayLength(item.key)}} {{ item.key }}
                            <span *ngIf="!last">,</span>
                        </ng-container>
                        <span (click)="exclusionComponent()" class="text-lg font-medium text-blue-500 cursor-pointer">View</span>
                    </div>
                </div>
        </div>
        
    </div>
    <div class="rounded-2xl bg-gray-200 px-7 py-8 ml-5 font-semibold flex items-center gap-5 w-50 justify-center" style="font-family: Montserrat;">
        <div>
            <span class="text-xl">{{customCodes.user_count}} Devices Linked</span>
            <br>
            <span style="font-size: 14px; font-weight: 500;">
                out of {{customCodes.user_limit}} Devices
            </span>
        </div>
    </div>
</div>